import { Control, RegisterOptions, FieldValues, Path } from "react-hook-form";
import { TextInputProps as CustomTextInputProps } from "../../components";

export const DEFAULT_COUNTRY_LABEL = "United States";
export const DEFAULT_COUNTRY_CODE = "USA";

export const capitalizeText = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export interface TextInputProps<T extends FieldValues> extends Omit<CustomTextInputProps, "theme"> {
  name: Path<T>;
  control: Control<T>;
  rules?: RegisterOptions;
  countryField?: Path<T>;
  withOnChangeText?: boolean;
}
